Vue.component('UsersSelect', () => import('./UsersSelect'))
Vue.component('YearsSelect', () => import('./YearsSelect'))
Vue.component('TermsSelect', () => import('./TermsSelect'))
Vue.component('CategoriesSelect', () => import('./CategoriesSelect'))
Vue.component('ClassificationsSelect', () => import('./ClassificationsSelect'))
Vue.component('ActivitiesSelect', () => import('./ActivitiesSelect'))
Vue.component('UnitsInput', () => import('./UnitsInput'))
Vue.component('NotesInput', () => import('./NotesInput'))
Vue.component('UnitsCalculation', () => import('./UnitsCalculation'))
Vue.component('CoursesSelect', () => import('./CoursesSelect'))
Vue.component('UiLoader', () => import('./UiLoader'))
Vue.component('UvaInput', () => import('./UvaInput'))
Vue.component('TitlesSelect', () => import('./TitlesSelect'))
Vue.component('TextInput', () => import('./TextInput'))
Vue.component('Toggler', () => import('./Toggler'))
Vue.component('SectionsSelect', () => import('./SectionsSelect'))
Vue.component('ButtonCancel', () => import('./ButtonCancel'))
Vue.component('ButtonConfirm', () => import('./ButtonConfirm'))
Vue.component('ButtonNavigate', () => import('./ButtonNavigate'))
Vue.component('FieldsSelect', () => import('./FieldsSelect'))
Vue.component('NormTypesSelect', () => import('./NormTypesSelect'))
Vue.component('ProgrammesSelect', () => import('./ProgrammesSelect'))
Vue.component('VSelect', () => import('./Select'))